import lang from "@/views/modules/UserDashlets/language/en";
import Editor from '@tinymce/tinymce-vue';


export default {
    name: "new-product",

    components: {

        'editor': Editor,
    },
    data() {
        return {
            loading: true,
            dom_array: [],
            lang: [],
            userdashlet: {
            },
            process:false,
        }
    },
    mounted() {
        this.lang = lang;
        this.dom_array = this.domArrayVariable;
        this.getUserDashlet();
    },
    methods: {
        saveUserDashlet() {
            const errorMessages = document.getElementsByClassName('error-message');
            while (errorMessages.length > 0) {
                errorMessages[0].remove();
            }

            const self = this;
            self.loading = true;

            if(self.userdashlet.name==''){
                self.userdashlet.name = self.dom_array.module_dashlet[self.userdashlet.module]
            }
            self.process = true;
            axios.put(`api/modules/userdashlets/${self.$route.params.id}`, self.userdashlet).then(function (response) {
                self.loading = false;
                self.process = false;
                self.$notify({
                    title: self.$i18n.t('Success').toString(),
                    text: self.$i18n.t('Data update correctly').toString(),
                    type: 'success'
                });
                self.$router.push('/modules/userdashlets');
            }).catch(function () {
                self.loading = false;
                let err = localStorage.getItem('Errors');
                let err_msg = (JSON.parse(err));
                let err_msg2 = err_msg.errors;
                Object.keys(err_msg2).forEach((key) => {
                    let errorval = err_msg2[key];
                    const input = document.getElementById(key);
                    const errorDiv = document.createElement('span');
                    errorDiv.className = 'error-message error';
                    errorDiv.textContent = errorval;
                    input.insertAdjacentHTML('afterend', errorDiv.outerHTML);
                });
                localStorage.removeItem('Errors');
            });
        },
        getUserDashlet() {
            const self = this;

            self.userdashlet.record = self.$route.params.id;
            
            if (typeof (self.userdashlet.record) != 'undefined') {
                let record_id = self.userdashlet.record;
                 window.currentAction = 'list';
                axios.get('api/modules/userdashlets/' + self.$route.params.id).then(function (response) {
                    self.userdashlet = response.data;
                    self.loading = false;
                }).catch(function () {
                    self.loading = false;
                });
            }
        },
        enableGraphType() {
            let gt = document.getElementById('gType');
            if (gt.checked == true) {
                this.disabled = false;
            } else {
                this.disabled = true;
            }
        }
    }
}